module.exports = __webpack_public_path__ + "img/shiftStations.98201535.svg";